<template>
  <div class="pc-bottom">
    <!-- 联系我们 -->
    <div class="gray-area outer">
      <div class="gray-area-in inner flc">
        <div class="contact">
          <div class="contact-title">联系我们</div>
          <div class="contact-list">
            <div class="contact-item">电话：15800728674</div>
            <div class="contact-item">网址：www.hongseliba.com</div>
            <div class="contact-item">邮箱：1276340728@qq.com</div>
            <div class="contact-item">地址：上海市杨浦区国康路同济大学国家大学科技园</div>
          </div>
        </div>
        <div class="qrcode flc">
          <!-- <div class="qrcode-title">企业微信</div>
          <img class="qrcode-img" :src="qr" /> -->
        </div>
      </div>
    </div>
    <!-- icp备案 -->
    <div class="icp-area outer">
      <div class="icp-areain inner flc">
        <!-- <div class="icp-txt">Copyright(C)2013-2024</div> -->
        <div class="icp-txt">上海伯泱信息科技有限公司</div>
        <a class="icp-txt" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备18044063号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
const qr = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/qr.png'
export default {
  name: 'pc-bottom',
  props: {},
  data() {
    return {
      qr
    }
  }
}
</script>

<style scoped lang="scss">
.pc-bottom {
  .gray-area {
    background-color: #4c4b4b;
    position: relative;
    z-index: 2;
    .gray-area-in {
      padding: 94px 150px;
      box-sizing: border-box;
      .contact {
        .contact-title {
          font-size: 28px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 28px;
        }
        .contact-list {
          .contact-item {
            font-size: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            color: rgba(255, 255, 255, 0.8);
            line-height: 20px;
            margin-top: 24px;
          }
        }
      }
      .qrcode {
        flex: 1;
        flex-direction: column;
        .qrcode-title {
          font-size: 28px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 28px;
          margin-bottom: 24px;
        }
        .qrcode-img {
          width: 120px;
          height: 120px;
          background-color: #fff;
        }
      }
    }
  }
  .icp-area {
    background-color: #fff;
    position: relative;
    z-index: 2;
    .icp-areain {
      height: 77px;
      .icp-txt {
        font-size: 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        color: #252525;
        line-height: 56px;
        margin: 0 75px;
        text-decoration: none;
      }
    }
  }
}
</style>
